import { apiClient } from './apiClient'
import type { AppNotification, NotificationListResult } from '../types/notifications'

interface ApiResponse<T> {
  success: boolean
  data?: T
  error?: string
}

function parseError(err: unknown, fallback: string): Error {
  const ax = err as { response?: { data?: { error?: string } }; message?: string }
  return new Error(ax.response?.data?.error || ax.message || fallback)
}

export async function fetchNotifications(
  limit = 50,
  offset = 0,
  unreadOnly = false
): Promise<NotificationListResult> {
  try {
    const res = await apiClient.get<ApiResponse<NotificationListResult>>('/notifications', {
      params: { limit, offset, unreadOnly: unreadOnly ? '1' : '0' },
    })
    return (
      res.data.data ?? {
        items: [],
        unreadCount: 0,
        total: 0,
      }
    )
  } catch (e) {
    throw parseError(e, 'Kunne ikke hente notifikationer')
  }
}

export async function markNotificationRead(id: number): Promise<void> {
  try {
    await apiClient.patch(`/notifications/${id}/read`)
  } catch (e) {
    throw parseError(e, 'Kunne ikke markere notifikation')
  }
}

export async function markAllNotificationsRead(): Promise<number> {
  try {
    const res = await apiClient.post<ApiResponse<{ marked: number }>>('/notifications/read-all')
    return res.data.data?.marked ?? 0
  } catch (e) {
    throw parseError(e, 'Kunne ikke markere notifikationer')
  }
}

export async function deleteNotification(id: number): Promise<void> {
  try {
    await apiClient.delete(`/notifications/${id}`)
  } catch (e) {
    throw parseError(e, 'Kunne ikke fjerne notifikation')
  }
}

export function isUnread(notification: AppNotification): boolean {
  return notification.readAt === null || notification.readAt === ''
}
